// overrides.js - Переопределения переводов из martyrs
// Переопределяем footer из core чтобы избежать hydration mismatch
import en from './en.json';
import ru from './ru.json';

export default {
  core: {
    en: { footer: en.footer },
    ru: { footer: ru.footer }
  }
};